import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import { isMobileApp } from '../../utils/api';

export const SpaExperienceFragmentEditConfig = {
  emptyLabel: 'Spa Experience Fragment',
  isEmpty: function(props: any): boolean {
    return !props || !props.fragmentVariationPath || props.fragmentVariationPath.trim().length < 1;
  },
};

class SpaExperienceFragment extends Component<any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);

    this.state = {
      xfContent: props.html
        ? props.html.substring(props.html.indexOf('<body class="xf-web-container">') + 31, props.html.indexOf('</body'))
        : 'SPA Experience Fragment Not found',
    };
  }

  render() {
    const { xfContent } = isMobileApp() ? '' : this.state;

    return <>{<div dangerouslySetInnerHTML={{ __html: xfContent }} />}</>;
  }
}

export default MapTo('workplace-spa/components/spaexperiencefragment')(
  SpaExperienceFragment,
  SpaExperienceFragmentEditConfig,
);
